const CartItems = [
    {
      id: 1,
      title: 'Book 1',
      price: 10.00,
      img: 'https://m.media-amazon.com/images/I/51-rgKn5NKL.jpg',
      amount: 1,
    },
    {
      id: 2,
      title: 'Book 2 ',
      price: 17.00,
      img: 'https://m.media-amazon.com/images/I/41OMXaT4MdL.jpg',
      amount: 1,
    },
    {
      id: 3,
      title: 'Book 3',
      price: 8.00,
      img: 'https://m.media-amazon.com/images/I/71CEW2OokEL._AC_UY436_FMwebp_QL65_.jpg',
      amount: 1,
    },
    {
      id: 4,
      title: 'Book 4',
      price: 9.00,
      img: 'https://m.media-amazon.com/images/I/A1pYHIsGS1L._AC_UY436_FMwebp_QL65_.jpg',
      amount: 1
    },
    {
      id: 5,
      title: 'Book 5',
      price: 9.00,
      img: 'https://m.media-amazon.com/images/I/9102hObxTJL._AC_UY436_FMwebp_QL65_.jpg',
      amount: 1
    }
  ];
  
  export default CartItems